import React, { useState, useEffect } from 'react';
import Draggable from 'react-draggable';
import './mChatroom.css';

const Chatroom = () => {
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [voice, setVoice] = useState(null); // Selected voice for TTS

  useEffect(() => {
    // Fetch available voices for TTS
    const getVoices = () => {
      const voices = window.speechSynthesis.getVoices();

      // Automatically select the UK English Male voice
      const ukEnglishMaleVoice = voices.find(
        (v) => v.lang === 'en-GB' && v.name.includes('Male')
      );

      if (ukEnglishMaleVoice) {
        setVoice(ukEnglishMaleVoice);
        console.log('Using voice:', ukEnglishMaleVoice.name);
      } else {
        console.warn('UK English Male voice not found. Using default voice.');
        if (voices.length > 0) {
          setVoice(voices[0]); // Fallback to the first available voice
        }
      }
    };

    // Ensure voices are loaded properly
    getVoices();
    window.speechSynthesis.onvoiceschanged = getVoices;
  }, []);

  const handleTTS = (text) => {
    if (!text || !voice) return;

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.voice = voice; // Use the selected UK English Male voice
    utterance.rate = 1; // Set speech rate (adjustable)
    utterance.pitch = 1; // Set speech pitch (adjustable)
    window.speechSynthesis.speak(utterance);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation: Check if input is empty or whitespace
    if (!message.trim()) {
      alert('Message cannot be empty!');
      return;
    }

    try {
      if (message.trim().length > 200) {
        alert('Message is too long! Please keep it under 200 characters.');
        return;
      }

      setMessages((prevMessages) => [...prevMessages, `You: ${message}`]);

      const res = await fetch(`https://justgotrugged.onrender.com/api/chat`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          message: message,
          platform: 'movinmonkey',
        }),
      });

      const data = await res.json();

      // Add bot's reply to chat history
      const botReply = 'Mr. Monkey: ' + data.reply;
      setMessages((prev) => [...prev, botReply]);

      // Use TTS to read out the reply
      handleTTS(data.reply);

      setMessage(''); // Clear the input field
    } catch (error) {
      console.error('Error:', error);

      setMessages((prev) => [
        ...prev,
        'Mr. Monkey: An error occurred. Please try again.',
      ]);

      // Read error message aloud
      handleTTS('An error occurred. Please try again.');
    }
  };

  return (
    <Draggable>
      <div className="mchatroom">
        <div className="mchatroom-header">speak-with-monkey</div>
        <div className="mchatroom-messages">
          {messages.map((msg, index) => (
            <div key={index} className="mchatroom-message">
              {msg}
            </div>
          ))}
        </div>
        <div className="mchatroom-input">
          <input
            type="text"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type a message..."
          />
          <button onClick={handleSubmit}>Send</button>
        </div>
      </div>
    </Draggable>
  );
};

export default Chatroom;
